// Marks a deployment's data upload complete beside the recordings.
import React, { useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import ConfirmationDialog from 'src/view/components/ConfirmationDialog';
import useDeploymentUploadStatus from 'src/hooks/useDeploymentUploadStatus';

const MarkCompleteButton: React.FC<{ deploymentId?: string | null }> = ({
  deploymentId,
}) => {
  const { complete, marking, error, markComplete } =
    useDeploymentUploadStatus(deploymentId);
  const [dialogOpen, setDialogOpen] = useState(false);

  if (!deploymentId) return null;

  const confirm = async () => {
    await markComplete();
    setDialogOpen(false);
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
      {complete ? (
        <Typography sx={{ fontSize: '11px', color: '#666', fontWeight: 600 }}>
          Data upload complete
        </Typography>
      ) : (
        <Button
          variant="outlined"
          onClick={() => setDialogOpen(true)}
          disabled={marking}
          sx={{
            fontSize: '10.5px',
            fontWeight: 800,
            color: '#10B981',
            borderColor: '#10B981',
            px: 2,
            height: '36px',
            textTransform: 'uppercase',
            letterSpacing: '0.5px',
            borderRadius: '8px',
            '&:hover': {
              borderColor: '#0D9268',
              background: 'rgba(16, 185, 129, 0.08)',
            },
          }}
        >
          {marking ? 'Marking…' : 'Mark Complete'}
        </Button>
      )}
      {error && (
        <Typography sx={{ fontSize: '10.5px', color: '#F59E0B' }}>{error}</Typography>
      )}
      <ConfirmationDialog
        open={dialogOpen}
        title="Mark As Complete"
        content="Are you sure you want to mark this deployment as complete? Once completed, you will not be able to upload any data for this deployment."
        confirmButtonText="Yes, Mark as Complete"
        loading={marking}
        onConfirm={confirm}
        onCancel={() => setDialogOpen(false)}
      />
    </Box>
  );
};

export default MarkCompleteButton;
